import { z } from 'zod';
import { PRODUCT_CONSTRAINTS } from './constraints.js';
import { productFormFieldsSchema } from './create-form.js';
const { label, maxLength } = PRODUCT_CONSTRAINTS.description;
// A LeafLink import stores its description uncut, so only a description the user changed is held to the typed-input cap.
export const productEditFormSchema = (savedDescription) => productFormFieldsSchema.extend({
    description: z
        .string()
        .trim()
        .refine((value) => value === savedDescription.trim() || value.length <= maxLength, `${label} must be ${maxLength.toLocaleString('en-US')} characters or fewer.`),
});
//# sourceMappingURL=edit-form.js.map